import { QueryClient } from '@tanstack/react-query';

export const queryClient = new QueryClient({
    defaultOptions: {
        queries: {
            staleTime: 60_000,
            gcTime: 5 * 60_000,
            refetchOnWindowFocus: false,
            retry: 1,
        },
    },
});

export const queryKeys = {
    advertiserAccount: ['advertiser-account'],
    fleetScreens: (view = 'full') => ['fleet-screens', view],
    advertiserHome: (advertiserId) => ['advertiser-home', advertiserId],
    campaignDetails: (adId) => ['campaign-details', adId],
    adminScreenInfo: (screenId) => ['admin-screen-info', screenId],
    hostDashboard: (userId) => ['host-dashboard', userId],
    screenPricing: ['screen-pricing'],
};
